module.exports = __webpack_public_path__ + "static/media/craft-item.3e25d017.png";